import { FC, ReactNode } from "react"
import { Modal, IconButton, Box, Typography } from "@mui/material"
import CloseIcon from "../../../assets/icons/CloseIcon"
import "./GenericModal.scss"
import Loader from "../../Loader/Loader.component"
import { CSS } from "styled-components/dist/types"

type GenericModalProps = {
  open: boolean
  className?: string
  handleClose: () => void
  title?: string
  image?: string | ReactNode
  description?: string
  description2?: string
  children?: ReactNode
  loading?: boolean
  imageStyle?: CSS.Properties
}

const GenericModal: FC<GenericModalProps> = ({
  open,
  className,
  handleClose,
  title,
  image,
  description,
  description2,
  children,
  loading,
  imageStyle
}) => {
  const isImageUrl = (image: string | ReactNode): image is string => {
    return typeof image === "string"
  }

  return (
    <Modal open={open} onClose={handleClose} className="app-modal">
      <Box className={`modal-box ${className}`}>
        {loading && <Loader />}
        <IconButton className="close-button" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        {title && <h3 className="modal-title">{title}</h3>}
        {image &&
          (isImageUrl(image) ? (
            <img src={image} alt={title} className="modal-image" style={imageStyle}/>
          ) : (
            <div className="modal-image">{image}</div>
          ))}
        {description && (
          <Typography variant="body1" className="modal-description one">
            {description}
          </Typography>
        )}
        {description2 && (
          <Typography variant="body1" className="modal-description two">
            {description2}
          </Typography>
        )}
        {children && <div className="modal-content">{children}</div>}
      </Box>
    </Modal>
  )
}

export default GenericModal
